import { EmmaPath } from './paths'

type LazyImportFn = () => Promise<unknown>

const routeImports: Record<string, LazyImportFn> = {
  [EmmaPath.CUSTOMER_LISTING]: () => import('@/pages/customerSearch'),
  [EmmaPath.CUSTOMER_CREATE]: () => import('@/pages/customer'),
  [EmmaPath.CUSTOMER_PAGE]: () => import('@/pages/customer'),
  [EmmaPath.CUSTOMER_NEW_LEADS]: () => import('@/pages/leads'),
  [EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE]: () => import('@/pages/leadsTriage'),
  [EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE_V2]: () => import('@/pages/leadsTriageV2'),
  [EmmaPath.CUSTOMER_AUTO_BOOKINGS]: () => import('@/pages/autoBooking'),
  [EmmaPath.CUSTOMER_ENHANCED_SALES]: () => import('@/pages/enhancedSales'),
  [EmmaPath.MOVE_MANAGER]: () => import('@/pages/moveManager'),
  [EmmaPath.MOVER_MOVES]: () => import('@/pages/moverMoves'),
  [EmmaPath.ADMIN_BRANCH_LISTING]: () => import('@/pages/branch'),
  [EmmaPath.ADMIN_BRANCH_CREATE]: () => import('@/pages/branch/Details'),
  [EmmaPath.ADMIN_BRANCH_UPDATE]: () => import('@/pages/branch/Details'),
  [EmmaPath.ADMIN_TRUCK_LISTING]: () => import('@/pages/truck'),
  [EmmaPath.ADMIN_TRUCK_CREATE]: () => import('@/pages/truck/Details'),
  [EmmaPath.ADMIN_TRUCK_UPDATE]: () => import('@/pages/truck/Details'),
  [EmmaPath.ADMIN_EMPLOYEE_LISTING]: () => import('@/pages/employee'),
  [EmmaPath.ADMIN_EMPLOYEE_CREATE]: () => import('@/pages/employee/Details'),
  [EmmaPath.ADMIN_EMPLOYEE_UPDATE]: () => import('@/pages/employee/Details'),
  [EmmaPath.ADMIN_TRIP_TRACKER_LISTING]: () => import('@/pages/tripTracker'),
  [EmmaPath.ADMIN_NPS_LISTING]: () => import('@/pages/nps'),
  [EmmaPath.ADMIN_RIPPLING_WORK_HOURS_LISTING]: () => import('@/pages/ripplingWorkHours'),
  [EmmaPath.REPORT_DIALPAD_STATS]: () => import('@/pages/report/dialpadStats'),
  [EmmaPath.REPORT_REVIEWS]: () => import('@/pages/report/reviews'),
  [EmmaPath.REPORT_DAMAGES]: () => import('@/pages/report/damage'),
  [EmmaPath.REPORT_ATTENDANCE_POINTS]: () => import('@/pages/report/attendancePoints'),
  [EmmaPath.ADMIN_PROBLEMS_LOCATIONS]: () => import('@/pages/problemLocation'),
  [EmmaPath.ADMIN_MOVE_REPORTS]: () => import('@/pages/moveReports'),
  [EmmaPath.ADMIN_CALENDAR_AVAILABILITIES]: () => import('@/pages/calendarAvailabilities'),
  [EmmaPath.ADMIN_PRICING_RULES]: () => import('@/pages/pricingRules'),
  [EmmaPath.ADMIN_ZIP_ZONES]: () => import('@/pages/zipZone'),
  [EmmaPath.ADMIN_SERVICE_ZONES]: () => import('@/pages/serviceZones'),
  [EmmaPath.ADMIN_MAP]: () => import('@/pages/report/map'),
  [EmmaPath.ADMIN_CRON_JOBS]: () => import('@/pages/cronJobs'),
  [EmmaPath.REPORT_KPIS]: () => import('@/pages/report/kpis'),
  [EmmaPath.REPORT_NPS]: () => import('@/pages/report/nps'),
  [EmmaPath.REPORT_GENERAL]: () => import('@/pages/report/general'),
  [EmmaPath.REPORT_TUR]: () => import('@/pages/report/tur'),
  [EmmaPath.REPORT_SALES]: () => import('@/pages/report/sales'),
  [EmmaPath.REPORT_SALES_PIPELINE]: () => import('@/pages/report/salesPipeline'),
  [EmmaPath.REPORT_REVENUE]: () => import('@/pages/report/revenue'),
  [EmmaPath.REPORT_OVER_TIME]: () => import('@/pages/report/overTime'),
  [EmmaPath.REPORT_SALES_DETAILS]: () => import('@/pages/report/sales/details'),
  [EmmaPath.REPORT_REVENUE_DETAILS]: () => import('@/pages/report/revenue/details'),
  [EmmaPath.REPORT_EINSTEIN_GAMES]: () => import('@/pages/report/einsteinGames'),
  [EmmaPath.REPORT_SETTINGS]: () => import('@/pages/report/settings'),
  [EmmaPath.REPORT_BILLABLE_EFFICIENCY]: () => import('@/pages/report/billableEfficiency'),
  [EmmaPath.ACCOUNT_MY_SCHEDULE]: () => import('@/pages/mySchedule'),
}

const prefetchedRoutes = new Set<string>()

export const prefetchRoute = (path: string) => {
  if (prefetchedRoutes.has(path)) return

  const importFn = routeImports[path]
  if (importFn) {
    prefetchedRoutes.add(path)
    importFn()
  }
}

export const getPrefetchHandlers = (path: string) => ({
  onMouseEnter: () => prefetchRoute(path),
  onFocus: () => prefetchRoute(path),
})
